export const membershipContent = {
  title: 'Membership',
  heroSection: {
    heading: 'Join NOTHS & More',
    copy: 'Oh, hello there. Fancy saving 10% on everything, all year round? Join our membership club today and get loads of other exclusive treats too. Read on to find out more…',
    textColorSetting: 'dark',
    backgroundColor: '#EEE9EF',
    imageUrl:
      'https://images.contentstack.io/v3/assets/blt63f2f7afd19b09c2/blt29582763cea346b8/69cfa093a96ebb51f3b954fe/image.jpg',
  },
  contentSection: [
    {
      heading: 'A special birthday treat from us',
      copy: 'To celebrate our 20th birthday, we’re giving you 50% off NOTHS & More membership with code N&M50. That’s 10% off everything for a whole year plus exclusive perks.',
      backgroundColor: '#EEE9EF',
      imageUrl:
        'https://images.contentstack.io/v3/assets/blt63f2f7afd19b09c2/bltedae35dff3b4c03b/69cfa09302aea8b80463886d/NM_standard_banner_-_sign_up.jpg',
    },
    {
      heading: 'Get 10% off everything',
      copy: 'That’s 10% off all your unique gifts, dazzling jewellery, delicious food and drink, homeware and more - for a whole year.',
      backgroundColor: '#EEE9EF',
      imageUrl:
        'https://images.contentstack.io/v3/assets/blt63f2f7afd19b09c2/blt6eedcaaf77bd62e0/69cfa09322934a23d344abaa/NM_standard_banner_-_10_off.jpg',
    },
    {
      heading: 'A big birthday treat',
      copy: 'We’ll send you an extra discount on your birthday. Go on, treat yourself.',
      backgroundColor: '#EEE9EF',
      imageUrl:
        'https://images.contentstack.io/v3/assets/blt63f2f7afd19b09c2/blt7dd5153868ef3550/69cfa094b60f83d8610045aa/NM_standard_banner_-_birthday.jpg',
    },
    {
      heading: 'Exclusive competitions and offers',
      copy: 'Enter members-only competitions and special offers, just for you.',
      backgroundColor: '#EEE9EF',
      imageUrl:
        'https://images.contentstack.io/v3/assets/blt63f2f7afd19b09c2/blta926230ece186375/69cfa09378b2b1161e76e03a/NM_standard_banner_-_competitions.jpg',
    },
    {
      heading: 'Extra inspiration',
      copy: 'From small business stories to edits curated just for you, you’ll also get access to exclusive inspiring content.',
      backgroundColor: '#EEE9EF',
      imageUrl:
        'https://images.contentstack.io/v3/assets/blt63f2f7afd19b09c2/bltaa7dfd50b4f29d56/69cfa093b4aabb991ca1adb8/NM_standard_banner_-_inspo.jpg',
    },
  ],
  questionsAndAnswersSection: {
    title: 'NOTHS & More FAQs',
    questionsAndAnswers: [
      {
        question: 'How much does the membership cost?',
        answer: 'NOTHS & More costs £10 for the year.',
      },
      {
        question: 'Do you pay monthly or annually?',
        answer:
          'NOTHS & More is a one-time cost for the entire year. This does not automatically renew.',
      },
      {
        question: 'Does the membership automatically renew?',
        answer:
          'Nope, NOTHS & More won’t automatically renew at the end of the 12-month period. However, we give you a gentle nudge that your membership is coming to an end – giving you plenty of time to repurchase for the following year.',
      },
      {
        question: 'Can anyone join NOTHS & More?',
        answer:
          'At the moment, NOTHS membership is only available to customers who are GB residents. We may look to expand this to more locations over time.',
      },
      {
        question: 'How do I receive the extra discount for my birthday?',
        answer:
          'When you sign up to the membership, we’ll send you an email requesting the date of your birthday. Once we’ve got that, we’ll send an email with your extra discount in the lead up to your birthday.',
      },
      {
        question: 'How do I receive exclusive content or competitions?',
        answer:
          'All exclusive NOTHS & More membership content will be sent to you via email – so *please* ensure you’re subscribed to marketing emails. You can do this within your account under marketing preferences.',
      },
      {
        question: 'What do you have to do to sign up?',
        answer:
          'Sign up to our membership by adding NOTHS & More to your basket or during your checkout process. You will be charged £10. Your discount will apply to that checkout, and, once your order is accepted and (for guest checkout users) you have activated your membership, to all subsequent checkouts for the next 12 months.',
      },
      {
        question: 'What if I do not have an account with Not On The High Street?',
        answer:
          'You can sign up for membership by creating an account when you checkout. If you prefer you can use our guest checkout to purchase your membership. If you use our guest checkout, you will be prompted to activate your membership via email. As part of activation we will create a NOTHS account that you can use to apply your discount on future purchases.',
      },
      {
        question: 'Is there more than one option?',
        answer:
          'We currently only have one version of NOTHS & More membership. However, keep your eyes peeled for more treats in the future.',
      },
      {
        question: 'Does the discount apply automatically?',
        answer:
          'Yep, as long as you are logged into your Not On The High Street account, the discount will be applied automatically. If we’re running a discount on site that is greater than 10% you can apply this, using our promo code box, instead. Please note that your membership discount won’t work alongside any other promotional or voucher codes.',
      },
      {
        question: 'Does the discount apply to already discounted sale items?',
        answer:
          'Yep, your NOTHS & More membership discount will apply to sale and discounted items. Please note, it won’t work alongside any other promotional or voucher codes. ',
      },
      {
        question: 'How does the membership discount work?',
        answer:
          'The membership discount applies to the value of the products in your basket. It does not apply to the cost of shipping. Products that are on sale are also eligible for the membership discount. You can use customer funds in conjunction with your membership discount.',
      },
    ],
  },
  errors: {
    ADD_TO_BASKET_ERROR:
      "Oops! We're having trouble adding membership to your basket. Please refresh the page or try again later.",
    FETCH_BASKET_ERROR:
      "Oops! We're having trouble loading your basket. Please refresh the page or try again later",
  },
  ctaText: {
    alreadyMember: "You're a member - enjoy the perks",
    default: 'Join today',
    inBasket: 'Added to basket',
  },
};
